import { render, staticRenderFns } from "./WebhookEndpoints.vue?vue&type=template&id=7216478e&"
import script from "./WebhookEndpoints.vue?vue&type=script&lang=ts&"
export * from "./WebhookEndpoints.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports